/// <amd-module name="Repos/Artifact/Discussion/CommonMarkdownProps" />
import { IDiscussionMarkdownEditorProps } from "Repos/Discussion/DiscussionThread.Types";
import { previewOptions } from "Repos/Discussion/Utils/Markdown";
import { shortcutCommands } from "VSS/Features/MarkdownEditor/Commands/Shortcut";
import { toolbarCommands } from "VSS/Features/MarkdownEditor/Commands/Toolbar";
import { IMarkdownPreviewProps, IMarkdownTextFieldProps, IMarkdownToolbarProps } from "VSS/Features/MarkdownEditor/Components";

function getMarkdownTextFieldProps(): IMarkdownTextFieldProps {
    return { shortcutCommands: [...shortcutCommands] };
}

function getMarkdownToolbarProps(contributionId?: string): IMarkdownToolbarProps {
    return { commands: [...toolbarCommands], contributionId };
}

function getMarkdownPreviewProps(): IMarkdownPreviewProps {
    return { options: { ...previewOptions } };
}

export function getMarkdownEditorProps(commandContributionId?: string): IDiscussionMarkdownEditorProps {
    return {
        previewProps: { ...getMarkdownPreviewProps() },
        textFieldProps: { ...getMarkdownTextFieldProps() },
        toolbarProps: { ...getMarkdownToolbarProps(commandContributionId) }
    };
}
